import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { SegundaViaContrato } from '../modelo/segundaViaContrato'; 

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-segundaviacarne-conclusao',
  templateUrl: './segundaviacarne-conclusao.component.html',
  styleUrls: ['./segundaviacarne.component.css']
})
export class SegundaViaCarneConclusaoComponent extends AbstractComponent implements OnInit {

  mensagem: string = "";
  cdMensagem: string = "";

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);

    if (sessionStorage.getItem("segundaViaContrato")) {
      var segundaViaContrato: SegundaViaContrato = JSON.parse(sessionStorage.getItem("segundaViaContrato"));
      this.mensagem = segundaViaContrato.dsMsgemRetorno;
      this.cdMensagem = segundaViaContrato.cdMsgemRetorno;
    }

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundaviacarne-cli/segundaviacarne-conclusao.component.ts